module.exports = __webpack_public_path__ + "static/media/Otto Mann.5bcc23a0.png";